import { z } from "zod";

export const LoginSchema = () =>
  z.object({
    email: z
      .string({
        required_error: JSON.stringify({
          key: "error.placeholder.enter",
          label: "email",
        }),
      })
      .email({
        message: JSON.stringify({
          key: "error.placeholder.invalid",
          label: "email",
        }),
      })
      .nonempty({
        message: JSON.stringify({
          key: "error.placeholder.enter",
          label: "email",
        }),
      }),
    password: z
      .string({
        required_error: JSON.stringify({
          key: "error.placeholder.enter",
          label: "password",
        }),
      })
      .min(
        4,
        JSON.stringify({
          key: "error.placeholder.password_length",
          length: "4",
        }),
      )
      .nonempty({
        message: JSON.stringify({
          key: "error.placeholder.enter",
          label: "password",
        }),
      }),
    remember_me: z.boolean().optional(),
  });

export type LoginFormValues = z.infer<ReturnType<typeof LoginSchema>>;
